import client from '@/http'

const load = (context, params) => {
  const uri = (params.bundleId && params.id) ? `pages/${params.id}/${params.bundleId}` : `pages/public/${params.code}`

  client.get(
    uri
  ).then(
    (res) => {
      context.commit('SET_PAGE', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const loadAdmin = (context, params) => {
  client.get(
    `pages/${params.id}`
  ).then(
    (res) => {
      context.commit('SET_PAGE', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const loadAll = (context, tableId) => {
  client.get(
    `pages/table/${tableId}`
  ).then(
    (res) => {
      context.commit('SET_PAGES', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const save = (context, params) => {
  if (params.id) {
    client.put(
      `pages/${params.id}`,
      params
    ).then(
      (res) => {
        context.commit('SET_PAGE', res.data)
      }
    ).catch(
      (err) => {
        console.error(err)
      }
    )
  } else {
    client.post(
      'pages',
      params
    ).then(
      (res) => {
        context.commit('PUSH_PAGE', res.data)
      }
    ).catch(
      (err) => {
        console.error(err)
      }
    )
  }
}

const remove = (context, pageId) => {
    client.delete(`pages/${pageId}`).then(
        () => {
            context.commit('REMOVE_PAGE', pageId)
        }
    ).catch(
        (err) => {
            console.error(err)
        }
    )
}

const toggle = (context, params) => {
  client.post(
    'pages/toggle',
    params
  ).then(
    (res) => {
      context.commit('SET_ACTIVE_STATE', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const addItem = (context, params) => {
  client.post(
    'pages/items',
    params
  ).then(
    (res) => {
      context.commit('PUSH_ITEM', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const editItem = (context, params) => {
  client.put(
    `pages/items/${params.id}`,
    params
  ).then(
    () => {
      context.commit('UPDATE_ITEM', params)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const removeItem = (context, pageItemIds) => {
  client.delete(
    `pages/items/${pageItemIds}`
  ).then(
    () => {
      context.commit('REMOVE_ITEM', pageItemIds)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const fetchChildren = (context, params) => {
  return client.post(
    (params.hasAccess) ? 'pages/values' : 'pages/public/values',
    params
  ).then(
    (res) => {
      if (params.mode !== 'grid') context.commit('EXPAND_TREE', res.data)
      return res.data
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const saveText = (context, params) => {
  return client.put(
    `pages/${params.pageId}/bundle/${params.bundleId}/text`, params
  ).then(
    () => {
      context.commit('SET_TEXT', params)
    }
  ).catch(
    e => {
      console.error(e)
    }
  )
}

export default {
  load,
  save,
  remove,
  toggle,
  loadAll,
  addItem,
  editItem,
  saveText,
  loadAdmin,
  removeItem,
  fetchChildren
}
